import {
	APPLE_PAY_SUBMIT,
	GOOGLE_PAY_SUBMIT,
	PROFILE_STRIPE_ERROR,
	PROFILE_STRIPE_SUCCES,
	STRIPE_ERROR,
	STRIPE_SUCCESS,
	VIPPS_ERROR,
	VIPPS_SUCCESS,
} from 'new-constants/payment.constants';
import {
	PROFILE_STRIPE_CARD_REGISTRATION_POPUP,
	STRIPE_CARD_REGISTRATION_POPUP,
} from 'new-components/popups/stripe-card-registration/StripeCardRegistration';
import {VIPPS_PAYMENT_FRAME_POPUP} from 'new-components/popups/vipps-payment-frame/VippsPaymentFrame';
import {VIPPS_ERROR_MESSAGE_POPUP} from 'new-components/popups/error-message/ErrorMessage';
import {
	MOBILE_PAY_SUBMIT,
	MOBILE_PAY_REDIRECT,
	ADYEN_SUCCESS,
	ADYEN_ERROR,
	SUBMIT_ADYEN_CARD_REGISTER, SUBMIT_ADYEN_CARD_ADDITIONAL_DETAILS, SWISH_PAY_SUBMIT, SWISH_PAY_SUBMIT_ADDITIONAL_DETAILS,
} from "../constants/payment.constants";
import {trackEvent} from "../helpers/tracking.helpers";
import {ADYEN_CARD_REGISTRATION_POPUP, ADYEN_GOOGLE_PAY_POPUP, STRIPE_THREE_DS_POPUP, SWISH_PAY_POPUP} from "../constants/popup.constants";

export const stripeSuccess = (restaurantId, orderId) => {
	trackEvent({
		event: 'Receive Stripe Success',
		properties: {
			'Venue Id': restaurantId,
			'Order Id': orderId,
		}
	});
	return {
		type: STRIPE_SUCCESS,
		hidePopups: [STRIPE_CARD_REGISTRATION_POPUP, STRIPE_THREE_DS_POPUP],
		restaurantId,
		orderId,
	}
};

export const stripeError = (restaurantId) => {
	trackEvent({
		event: 'Stripe Error',
		properties: {
			'Venue Id': restaurantId,
		}
	});
	return {
		type: STRIPE_ERROR,
		hidePopups: [STRIPE_CARD_REGISTRATION_POPUP],
	}
};

export const profileStripeSuccess = (orderId, restaurantId) => {
	trackEvent({
		event: 'Receive Profile Stripe Success',
		properties: {
			'Venue Id': restaurantId,
			'Order Id': orderId,
		}
	});
	return {
		type: PROFILE_STRIPE_SUCCES,
		hidePopups: [PROFILE_STRIPE_CARD_REGISTRATION_POPUP],
		orderId,
	}
};

export const profileStripeError = (restaurantId) => {
	trackEvent({
		event: 'Receive Profile Stripe Error',
		properties: {
			'Venue Id': restaurantId,
		}
	});
	return {
		type: PROFILE_STRIPE_ERROR,
	}
};

export const vippsSuccess = (restaurantId, orderId) => {
	trackEvent({
		event: 'Receive Vipps Success',
		properties: {
			'Venue Id': restaurantId,
			'Order Id': orderId,
		}
	});
	return {
		type: VIPPS_SUCCESS,
		hidePopups: [VIPPS_PAYMENT_FRAME_POPUP],
		restaurantId,
		orderId,
	}
};

export const vippsError = (message, restaurantId) => {
	trackEvent({
		event: 'Receive Vipps Error',
		properties: {
			'Venue Id': restaurantId,
			'Message': message,
		}
	});
	return {
		type: VIPPS_ERROR,
		showPopup: VIPPS_ERROR_MESSAGE_POPUP,
		hidePopups: [VIPPS_PAYMENT_FRAME_POPUP],
		message,
	}
};

export const mobilePaySubmit = (restaurantId) => {
	trackEvent({
		event: 'Receive Mobile Pay Submit',
		properties: {
			'Venue Id': restaurantId,
		}
	});
	return {
		type: MOBILE_PAY_SUBMIT,
	}
};

export const mobilePayRedirect = (currentTemporaryOrderId, restaurantId) => {
	trackEvent({
		event: 'Receive Mobile Pay Redirect',
		properties: {
			'Venue Id': restaurantId,
		}
	});
	return {
		type: MOBILE_PAY_REDIRECT,
		currentTemporaryOrderId
	}
};

export const submitAdyenCardRegister = (data, redirectToOrder = true) => {
	return {
		type: SUBMIT_ADYEN_CARD_REGISTER,
		data,
		redirectToOrder,
	}
};

export const initSwishPayment = (data) => {
	return {
		type: SWISH_PAY_SUBMIT,
		data,
	}
};

export const submitAdyenCardAdditionalDetails = (data, redirectToOrder = true) => {
	return {
		type: SUBMIT_ADYEN_CARD_ADDITIONAL_DETAILS,
		data,
		redirectToOrder,
		hidePopups: [ADYEN_CARD_REGISTRATION_POPUP, ADYEN_GOOGLE_PAY_POPUP],
		showLoading: true,
	}
};
export const submitSwishPaymentAdditionalDetails = (data) => {
	return {
		type: SWISH_PAY_SUBMIT_ADDITIONAL_DETAILS,
		data,
	}
};
export const adyenSuccess = (restaurantId, orderId) => {
	trackEvent({
		event: 'Receive Adyen Success',
		properties: {
			'Venue Id': restaurantId,
			'Order Id': orderId,
		}
	});
	return {
		type: ADYEN_SUCCESS,
		hidePopups: [ADYEN_CARD_REGISTRATION_POPUP],
		restaurantId,
		orderId,
	}
};

export const adyenError = (restaurantId) => {
	trackEvent({
		event: 'Adyen Error',
		properties: {
			'Venue Id': restaurantId,
		}
	});
	return {
		type: ADYEN_ERROR,
		hidePopups: [ADYEN_CARD_REGISTRATION_POPUP],
	}
};

export const initGooglePayPayment = (data) => {
	return {
		type: GOOGLE_PAY_SUBMIT,
		data,
	}
};

export const initApplePayPayment = (data) => {
	return {
		type: APPLE_PAY_SUBMIT,
		data,
	}
};
